<template>
  <v-layout>
    <v-flex class="margin">
      <!-- mobile -->
      <div v-if="mobileView" id="e3" style="max-width: 400px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-flex class="texefild-mobile">สร้างรายการ</v-flex>
          </v-toolbar>

          <v-form>
            <v-container fluid grid-list-lg>
              <v-layout>
                <v-flex>
                  <span class="text-b">ร้านค้า : </span>
                  <v-select style="margin-top: 10px" label="เลือกร้านค้า" solo :items="itemsMerchant"
                    v-model="merchantName" ref="merchantName"
                    :rules="[() => !!merchantName || 'กรุณาเลือกร้านค้า']"></v-select>
                </v-flex>
              </v-layout>
              <v-layout style="margin-top: -20px">
                <v-flex>
                  <span class="text-b">ชื่อลูกค้า : </span>
                  <v-text-field style="margin-top: 10px" label="กรอกชื่อลูกค้า" solo v-model="customerName"
                    ref="customerName" :rules="[() => !!customerName || 'กรุณากรอกชื่อลูกค้า']"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout style="margin-top: -15px">
                <v-flex md4>
                  <v-text-field label="กรอกข้อมูลเลขอ้างอิง" solo v-model="orderId" ref="orderId" :rules="[
                    () =>
                      !orderId || /^[A-Za-z0-9_-]{1,20}$/.test(orderId) ||
                      'ใส่ได้ 20 ตัวอักษร เฉพาะตัวอักษรภาษาอังกฤษ (A-Z , a-z), ตัวเลข (0-9) และอักษรพิเศษใช้ได้เฉพาะ _ และ -'
                  ]"></v-text-field>
                </v-flex>
              </v-layout>

              <!-- <v-layout style=" margin-top: -30px">
                    <v-flex class="alertmobile red--text">
                      <span>* ใส่ได้ 20 ตัวอักษร เฉพาะตัวอักษรภาษาอังกฤษ (A-Z , a-z) ,
                        ตัวเลข (0-9) และอักษรพิเศษใช้ได้เฉพาะ _ และ -</span>
                    </v-flex>
              </v-layout> -->

              <v-layout style="margin-top: -15px">
                <v-flex>
                  <span class="text-b">ยอดเงิน : </span>
                  <v-text-field style="margin-top: 10px" label="กรอกข้อมูลยอดเงิน" solo v-model="amount" ref="amount"
                    :rules="[
                      () => !!amount || 'กรุณากรอกข้อมูลยอดเงิน',
                      () =>
                        /^[0-9]+([.][0-9]{1,2})?$/.test(amount) ||
                        'กรุณาใส่จุดทศนิยมไม่เกิน 2 ตำแหน่ง',
                    ]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout style="margin-top: -15px">
                <v-flex>
                  <span class="text-b">จดบันทึก : </span>
                  <v-text-field style="margin-top: 10px" label="กรอกข้อมูล" solo v-model="description"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="layoutBtnMobile">
                  <v-btn color="#216AA9" dark @click="onClickGen"
                    style="font-size: 15px; border-radius: 3px">ยืนยัน</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </div>

      <!-- dialog for duplicate reference warning -->
      <v-dialog v-model="dialogVisible" max-width="500">
        <v-card class="headline"
          style="padding-top: 50px; display: flex; flex-direction: column; align-items: center; box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);">
          <v-icon color="red" size="100">mdi-close-circle</v-icon>
          <v-card-title
            style="padding-top: 20px; border-radius: 20px; text-align: center; display: flex; align-items: center; gap: 8px;">
            {{ dialogMessage }}
          </v-card-title>

          <v-card-actions
            style="width: 100%; display: flex; justify-content: center; padding-bottom: 30px; padding-top: 30px;">
            <v-btn color="#216AA9" dark text @click="dialogVisible = false" style="border-radius: 3px;">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- web -->
      <div v-if="!mobileView" id="e3" style="max-width: 1500px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>สร้างรายการ</v-toolbar-title>
          </v-toolbar>

          <v-form>
            <v-container fluid grid-list-lg>
              <v-layout style="margin-top: 20px">
                <v-flex md1 class="text_b">
                  <span>ร้านค้า : </span>
                </v-flex>
                <v-flex md4>
                  <v-select placeholder="เลือกร้านค้า" solo label="เลือกร้านค้า" :items="itemsMerchant"
                    v-model="merchantName" ref="merchantName" :rules="[() => !!merchantName || 'กรุณาเลือกร้านค้า']">
                  </v-select>
                </v-flex>
                <!-- <span></span> -->
                <v-flex md2 class="text_b">
                  <span>เลขอ้างอิงรายการ : </span>
                </v-flex>
                <v-flex md4>
                  <v-text-field label="กรอกข้อมูลเลขอ้างอิง" solo v-model="orderId" ref="orderId" :rules="[
                    () =>
                      !orderId || /^[A-Za-z0-9_-]{1,20}$/.test(orderId) ||
                      'ใส่ได้ 20 ตัวอักษร เฉพาะตัวอักษรภาษาอังกฤษ (A-Z , a-z), ตัวเลข (0-9) และอักษรพิเศษใช้ได้เฉพาะ _ และ -'
                  ]"></v-text-field>
                </v-flex>

              </v-layout>

              <v-layout style="margin-top: 10px">
                <v-flex md1 class="text_b">
                  <span>ชื่อลูกค้า : </span>
                </v-flex>
                <v-flex md4>
                  <v-text-field label="กรอกชื่อลูกค้า" solo v-model="customerName" ref="customerName"
                    :rules="[() => !!customerName || 'กรุณากรอกชื่อลูกค้า']"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout style="margin-top: 10px">
                <v-flex md1 class="text_b">
                  <span>ยอดเงิน : </span>
                </v-flex>
                <v-flex md4>
                  <v-text-field label="กรอกข้อมูลยอดเงิน" solo v-model="amount" ref="amount" :rules="[
                    () => !!amount || 'กรุณากรอกข้อมูลยอดเงิน',
                    () =>
                      /^[0-9]+([.][0-9]{1,2})?$/.test(amount) ||
                      'กรุณาใส่จุดทศนิยมไม่เกิน 2 ตำแหน่ง',
                  ]"></v-text-field>
                </v-flex>

                <v-flex md2 class="text_b">
                  <span>จดบันทึก : </span>
                </v-flex>
                <v-flex md4>
                  <v-text-field label="กรอกข้อมูล" solo v-model="description"></v-text-field>
                </v-flex>
              </v-layout>

              <!-- <div class="d-flex">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <v-btn
                  color="#41BAD7"
                  dark
                  @click="onClickGen"
                  style="width: 8px"
                  >ยืนยัน</v-btn
                >
              </div> -->
              <v-layout>
                <v-flex class="layoutBtn">
                  <v-btn color="#216AA9" dark @click="onClickGen"
                    style="font-size: 17px; border-radius: 3px">ยืนยัน</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      mobileView: false,
      itemsMerchant: [],
      merchantName: "",
      customerName: "",
      orderId: "",
      amount: "",
      description: "",
      dialogVisible: false, // Controls dialog visibility
      dialogMessage: "", // Holds the dialog message
    };
  },
  methods: {
    checkField() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (f !== "orderId" && !this.$refs[f].validate()) { // ยกเว้น orderId
          this.formHasErrors = true;
          this.$refs[f].validate(true);
        }
      });
    },

    async onClickGen() {
      this.checkField();
      if (!this.formHasErrors) {
        let json_data = {
          merchant_name: this.merchantName,
          customer_name: this.customerName,
          order_id: this.orderId,
          amount: this.amount,
          description: this.description,
        };

        try {
          var { data: data_genlink } = await this.axios.post(
            process.env.VUE_APP_APIHOST + "/gen_link_newcashier",
            { source: json_data },
            { headers: { Authorization: this.$cookies.get("token") } }
          );

          if (data_genlink.status == "validate" && !this.formHasErrors) {
            this.$cookies.set("link", data_genlink.data.link);
            localStorage.setItem("imageQR", data_genlink.data.qrcode);
            this.$router.push("/paymentGenerator");
          } else if (data_genlink.status == "repeat") {
            this.dialogMessage = "หมายเลขอ้างอิงซ้ำ";
            this.dialogVisible = true;
          } else if (data_genlink.message === "Order ID is already in use.") {
            this.dialogMessage = "หมายเลขอ้างอิงรายการซ้ำ";
            this.dialogVisible = true;
          } else {
            this.dialogMessage = "เลขอ้างอิงรายการไม่ถูกต้อง";
            this.dialogVisible = true;
          }
        } catch (er) {
          console.error("Error generating link:", er);
          if (data_genlink.message === "Order ID is already in use.") {
            this.dialogMessage = "หมายเลขอ้างอิงรายการซ้ำ";
            this.dialogVisible = true;
          } else {
            this.dialogMessage = "เกิดข้อผิดพลาดในการสร้างลิงก์ กรุณาลองใหม่อีกครั้ง";
            this.dialogVisible = true;
          }
        }
      }
    },

    handleView() {
      this.mobileView = window.innerWidth <= 990;
      this.$cookies.set("screenView", this.mobileView);
    },

    async merchantsList() {
      try {
        var { data } = await this.axios.get(
          `${process.env.VUE_APP_APIHOST}/merchants_list`,
          {
            headers: {
              Authorization: this.$cookies.get("token"),
            },
          }
        );
        this.itemsMerchant = data;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
  created() {
    this.handleView();
    this.merchantsList();
  },
  computed: {
    form() {
      return {
        merchantName: this.merchantName,
        customerName: this.customerName,
        orderId: this.orderId,
        amount: this.amount,
      };
    },
  },
};
</script>


<style>
.text {
  font-size: 17px;
}

.margin {
  margin-top: 15px;
}

.layout-btn {
  justify-content: end;
}

.text_b {
  text-align: center;
  margin-top: 5px;
  font-weight: bold;
  font-size: 18px;
}

.text-b {
  text-align: left;
  margin-top: 5px;
  font-weight: bold;
}

.alert {
  font-size: 12px;
  text-align: red;
  transform: translateY(-25px);
}

.alertmobile {
  font-size: 12px;
  text-align: red;
  transform: translateY(-9px);
}

.layoutBtn {
  text-align: right;
  width: 20px;
}

.layoutBtnMobile {
  text-align: right;
}

.v-text-field-title {
  border: #ccc;
  border-radius: 5px;
}

.texefild-mobile {
  font-size: 18px;
}
</style>
